import { render, staticRenderFns } from "./addPost.vue?vue&type=template&id=19f13039&scoped=true&"
import script from "./addPost.vue?vue&type=script&lang=js&"
export * from "./addPost.vue?vue&type=script&lang=js&"
import style0 from "./addPost.vue?vue&type=style&index=0&id=19f13039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f13039",
  null
  
)

export default component.exports